export const RECONNECT_KEY = 'reconnect-wallet-id';
